import css from './BusinessComp.module.css';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Clarical from '../../assets/svg/ClaricalWork.svg';
import receptionist from '../../assets/svg/receptionist.svg';
import daily from '../../assets/svg/daily.svg';
import bar from '../../assets/svg/bar.svg';
import cook from '../../assets/svg/cook.svg';
import dishwasher from '../../assets/svg/dishwasher.svg';
import picker from '../../assets/svg/picker.svg';
import warehouse from '../../assets/svg/warehouse.svg';
import production from '../../assets/svg/production.svg';
import inventory from '../../assets/svg/inventory.svg';
import wrapper from '../../assets/svg/wrapper.svg';
import selfstocker from '../../assets/svg/selfstocker.svg';

export default function BusinessComp() {
  return (
    <>
      <div className={css.BusinessComp}>
        <div className={css.BusinessCompBox}>
          <span className={css.businessboxheading}><FormattedMessage id='BusinessComp.AdministrativeStaff'/></span>
          <div className={css.BusinessCompBoxElement}>
            <div className={css.boxitem1}>
              <div className={css.icon}>
                <img src={Clarical} alt="" />
                <div className={css.icontext}> <FormattedMessage id='BusinessComp.ClaricalWork'/></div>
              </div>
              <div className={css.icon}>
                <img src={receptionist} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.Receptionist'/></div>
              </div>
            </div>
            <div className={css.boxitem2_1}>
              <img src={daily} alt="" />
              <div className={css.icontext}><FormattedMessage id='BusinessComp.Daily'/> </div>
            </div>
          </div>
        </div>

        <div className={css.BusinessCompBox}>
        <div className={css.businessboxheading}><FormattedMessage id='BusinessComp.Restaurants'/></div>

          <div className={css.BusinessCompBoxElement}>
            <div className={css.boxitem2}>
              <img src={bar} alt="" />
              <div className={css.icontext}><FormattedMessage id='BusinessComp.Waiter'/></div>
            </div>
            <div className={css.boxitem1}>
              <div className={css.icon}>
                <img src={cook} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.LineCook'/></div>
              </div>
              <div className={css.icon}>
                <img src={dishwasher} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.Dish'/></div>
              </div>
            </div>
          </div>
        </div>

        <div className={css.BusinessCompBox}>
          <div className={css.businessboxheading}><FormattedMessage id='BusinessComp.Logistics'/></div>
          <div className={css.BusinessCompBoxElement}>
            <div className={css.boxitem1}>
              <div className={css.icon}>
                <img src={picker} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.Picker'/></div>
              </div>
              <div className={css.icon}>
                <img src={warehouse} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.Warehouse'/></div>
              </div>
            </div>
            <div className={css.boxitem2}>
              <img src={production} alt="" />
              <div className={css.icontext}><FormattedMessage id='BusinessComp.Production'/></div>
            </div>
          </div>
        </div>

        <div className={css.BusinessCompBox}>
        <div className={css.businessboxheading}><FormattedMessage id='BusinessComp.Retail'/></div>

          <div className={css.BusinessCompBoxElement}>
            <div className={css.boxitem2}>
              <img src={inventory} alt="" />
              <div className={css.icontext}><FormattedMessage id='BusinessComp.Inventory'/></div>
            </div>
            <div className={css.boxitem1}>
              <div className={css.icon}>
                <img src={wrapper} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.Wrapper'/> </div>
              </div>
              <div className={css.icon}>
                <img src={selfstocker} alt="" />
                <div className={css.icontext}><FormattedMessage id='BusinessComp.Shelf'/> </div>
              </div>
            </div>
          </div>
        </div>
 
      </div>
    </>
  );
}
